import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

export interface PageHeaderActionItem {
  id: string;
  label: string;
  variant?: 'primary' | 'secondary';
  prefix?: string;
  icon?: string;
  cssClass?: string | string[];
}

@Component({
  selector: 'app-page-header-actions',
  imports: [CommonModule, TranslatePipe, IonIcon],
  templateUrl: './page-header-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-header-actions.component.scss',
})
export class PageHeaderActionsComponent {
  eyebrow = input<string | null>(null);
  title = input.required<string>();
  description = input<string | null>(null);
  actions = input<readonly PageHeaderActionItem[]>([]);
  useTranslate = input(true);

  actionClick = output<string>();

  protected onActionClick(actionId: string) {
    this.actionClick.emit(actionId);
  }
}
